"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/acct.ts
var acct_exports = {};
__export(acct_exports, {
  parse: () => parse,
  toString: () => toString
});
module.exports = __toCommonJS(acct_exports);
function parse(acct) {
  if (acct.startsWith("@")) acct = acct.slice(1);
  const split = acct.split("@", 2);
  return { username: split[0], host: split[1] || null };
}
function toString(acct) {
  return acct.host == null ? acct.username : `${acct.username}@${acct.host}`;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  parse,
  toString
});
